export const QevoltData = () => {
  const AccordionData = [
    {
      title: 'What is Qevolt',
      description:
        'Qevolt is a b2b tool that helps businesses accept and verify bank transfers easily. With Qevolt, you always want to receive your payments through bank transfers — it’s fast, safe, reliable and scam-proof',
      panel: 'panel1',
    },
    {
      title: 'What does Qevolt charge?',
      description:
        'We’ve created a pricing plan that accommodates all businesses. We charge 0.5% per transaction and a flat payout fee of #20. Fees are capped #500, and the 0.5% charge is waived for transactions less than #1000. For example, if you receive a transfer of #10,000, a charge of #70 will be removed (i.e #50 plus a flat fee of #20)',
      panel: 'panel2',
    },
    {
      title: 'Do I need to pay to get started?',
      description: 'No, setup is completely free',
      panel: 'panel3',
    },
    {
      title: 'Can I use Qevolt if my business is not registered?',
      description:
        'Yes, Qevolt is for all types of businesses. If you own an unregistered/small business, you only need to sign up using your basic business details and an outlet is created for you',
      panel: 'panel4',
    },
    {
      title: 'How does Qevolt verify transfers?',
      description:
        ' The transactions come into the virtual account we created with our partnered bank, we’re immediately notified when a transaction reflects. Fake or reversed transactions won’t appear on your dashboard',
      panel: 'panel5',
    },
    {
      title: 'Can I add my employees to verify payments too?',
      description:
        'If you’re an unregistered business, you can only assign cashiers to your outlet to accept and verify payments on your behalf. But registered businesses can also add outlet managers to oversee the activities and update outlet information',
      panel: 'panel6',
    },
    {
      title: 'Does Qevolt retain my funds after accepting it?',
      description:
        'No! Qevolt instantly deposits verified payments into the bank account you signed up with. Your funds are completely safe! Even when you have assigned your employees to be cashiers and managers. Their functions are limited and they have no access or control over business money',
      panel: 'panel7',
    },
    {
      title: 'Can I use Qevolt without owning a physical shop/store',
      description:
        'Yes. Whether you’re a one-man business (uber driver, freelancer, etc) or you own multiple stores, you can create an outlet/outlets to verify payments made to your business',
      panel: 'panel8',
    },
    {
      title: "Why can't I edit my business name?",
      description:
        'Only registered businesses that have uploaded their CACs can sign up with their business names. For unregistered businesses, your full name represents your business',
      panel: 'panel9',
    },
    {
      title: 'How long does the payout take?',
      description:
        'Payments accepted on Qevolt are paid out immediately to your bank account. Not a second more.',
      panel: 'panel10',
    },
    {
      title: 'How do I access support?',
      description:
        'Visit our website to chat with us. You can also send us a mail at support@qevolt.com or call us on 01-8880277. We’re always here to help',
      panel: 'panel11',
    },
    {
      title: "I don't see an option to create an outlet.",
      description:
        'Unregistered businesses can create only one outlet for receiving and verifying payments',
      panel: 'panel12',
    },
    {
      title: "I can't see my account number after signing up.",
      description:
        'After you sign up, you will automatically be given a 10-digit virtual account number that you will share with customers to receive payments',
      panel: 'panel13',
    },
  ];

  return { AccordionData };
};
